import React from 'react'
import { useTranslation } from 'react-i18next';

import { BUTTON_URL } from '../../constants';

import './getStart.scss';

const GetStart = () => {
    const { t } = useTranslation();

    return (
        <div id="get_start">
            <div className="wrapper">
                <div className="title">{t("titleGetStart")}</div>
                <div className="content-list">
                    <div className="personal main-content">
                        <div className="personal content-title">{t('titlePersonal')}</div>
                        <div className="personal description">{t('descPersonal')}</div>
                        {/* <a href={BUTTON_URL.vg} className="personal" target='_blank' rel="noopener noreferrer">{t('btnLetsGo')}</a> */}
                        <div className="coming-soon-btn">Coming soon</div>
                    </div>
                    <div className="business main-content">
                        <div className="business content-title">{t('titleBusiness')}</div>
                        <div className="business description">{t('descBusiness')}</div>
                        <a href={BUTTON_URL.vbt} className="business" target='_blank' rel="noopener noreferrer">{t('btnLetsGo')}</a>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default GetStart;
